///<reference path="../shared/frendsUtils-module.ts"/>

module ProcessList {
    export var module = angular.module("ProcessListModule", ["SignalR", "ui.router", "ui.bootstrap", "frends-utils", "SharedEnvironmentsModule", "ngTagsInput", "angular.filter", "ui.bootstrap.datetimepicker", "ngAnimate", "ui.select", "ngSanitize"])
    export const DEFAULT_ENV_NAME = "Default";
    module.config([
        "$stateProvider", "$locationProvider", "$urlRouterProvider", "$urlMatcherFactoryProvider", "$compileProvider", function (
            $stateProvider: ng.ui.IStateProvider,
            $locationProvider: ng.ILocationProvider,
            $urlRouterProvider: ng.ui.IUrlRouterProvider,
            $urlMatcherFactoryProvider: ng.ui.IUrlMatcherFactory,
            $compileProvider: ng.ICompileProvider) {

            // Removes trailing slash before hitting the stateProvider.
            $urlMatcherFactoryProvider.strictMode(false);

            $compileProvider.debugInfoEnabled(false);

            $stateProvider
                .state("environment", {
                    url: "/Process/List44/:environmentName?tag&filter&timelimit&processPage&highlightProcess&reverseSort&orderByField",
                    templateUrl: "ProcessListRootTemplate",
                    controller: "ProcessListController as ctrl",
                    reloadOnSearch: false
                }).state("environment.processInstanceList", {
                    url: "/ProcessInstanceList/:processId?sortColumn&sortDirection&filterString&stateFilter&page&executionId&itemsPerPage&startTimeLimitUtc&endTimeLimitUtc",
                    views: {
                        'instance-list': {
                            templateUrl: "ProcessInstanceListTemplate",
                            controller: "ProcessInstanceListController as ctrl"
                        }
                    }
                });

            $locationProvider.html5Mode(true);
            $urlRouterProvider
                .when("/Process/List44", "/Process/List44/Default");
        }
    ]);
}